import type { Country } from '@seek/chalice-types';

import type { DataLayer } from '../DataLayer';
import { filterBlanks } from '../utils/filterBlanks';

export const mapSiteCountry = (siteCountry: Country): DataLayer =>
  filterBlanks({
    siteCountry: (siteCountry || '').toLowerCase(),
  });
